<template>
  <div>
    <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial">
      <span style="cursor: pointer">
        <a-avatar class="avatar" size="small" shape="circle"
                  :src="avatar"/>
        <span class="curr-user">{{user.username}}</span>
      </span>
      <a-menu style="width: 150px" slot="overlay">
        <a-menu-item @click="openProfile">
          <a-icon type="user"/>
          <span>个人中心</span>
        </a-menu-item>
        <a-menu-item @click="updatePassword()">
          <a-icon type="key"/>
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="handleSettingClick">
          <a-icon type="setting"/>
          <span>系统定制</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="logout">
          <a-icon type="logout"/>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>

    <!--<update-password-->
    <!--@success="handleUpdate"-->
    <!--@cancel="handleCancelUpdate"-->
    <!--:user="user"-->
    <!--:updatePasswordModelVisible="updatePasswordModelVisible">-->
    <!--</update-password>-->

    <!-- 编辑弹出框 -->
    <el-dialog title="密码修改" :visible.sync="editVisible" width="25%" :user="user" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="旧密码:" >
          <el-input v-model="form.oldPassword"  style="width: 200px">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码:">
          <el-input v-model="form.newPassword"  style="width: 200px">
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码:" >
          <el-input v-model="form.newPassword2"  style="width: 200px">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {mapMutations, mapState} from 'vuex'
  import md5 from 'js-md5';

  export default {
    name: 'HeaderAvatar',
    data() {
      return {
        form: {
          oldPassword: '',
          newPassword: '',
          newPassword2: '',
        },
        editVisible: false,
        rules: {
          oldPassword: [{
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }],
          newPassword: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }, {
            min: 8,
            max: 20,
            message: '长度在 8 到 20 个字符'
          }, {
            pattern: /^(\w){6,20}$/,
            message: '请输入包含大写字母、小写字母、数字、标点及特殊字符四种字符中至少三种的组合'
          }],
          newPassword2: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }, {
            min: 8,
            max: 20,
            message: '长度在 8 到 20 个字符'
          }, {
            pattern: /^(\w){6,20}$/,
            message: '请输入包含大写字母、小写字母、数字、标点及特殊字符四种字符中至少三种的组合'
          }, {
            validator(callback) {
              if (this.$refs.newPassword.value !== this.$refs.newPassword2.value) {
                callback(new Error("两次密码不一致"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
          ],
        },

      }
    },
    computed: {
      ...mapState({
        settingBar: state => state.setting.settingBar.opened,
        user: state => state.account.user
      }),
      avatar() {
        return `static/avatar/${this.user.avatar}`
      }
    },
    methods: {
      handleSettingClick() {
        this.setSettingBar(!this.settingBar)
      },
      openProfile() {
        this.$router.push('/profile')
      },
      updatePassword() {
        this.editVisible = true
      },
      // 保存编辑
      saveEdit() {
        var oldPassword=this.form.oldPassword;
        var newPassword=this.form.newPassword;
        var newPassword2=this.form.newPassword2;

        if (newPassword!== newPassword2) {
          alert("两次输入的新密码不一致")
        }else{
          var np = this.passwordValidates(newPassword);
          var np2 =this.passwordValidates(newPassword2);
          if (!np && !np2) {
            return false;
          } else {
            this.$post('uac_user/password',{
              username: this.user.username,
              oldPassword: md5(oldPassword),
              password: md5(newPassword2),
            }).then((res) => {                  //这里使用了ES6的语法
              if (res.data.code===0) {
                this.editVisible = false;
                alert("修改成功，请重新登录")
                this.logout();
              } else
                alert(res.data.msg)
            }).catch((error) => {
              alert(error.message)  //请求失败返回的message
            })
          }
        }
      },


      logout() {
        this.$get(`logout/${this.user.userId}`).then(() => {
          return new Promise((resolve, reject) => {
            this.$db.clear()
            location.reload()
          })
        }).catch(() => {
          //this.$message.error('退出系统失败')
          //不管有没有请求成功， 都退出系统
          return new Promise((resolve, reject) => {
            this.$db.clear()
            location.reload()
          })
        })
      },
      ...mapMutations({setSettingBar: 'setting/setSettingBar'}),


      //正则表达式至少包含大写字母、小写字母、数字、特殊符号四种中的任三种
      passwordValidates(str) {
        var rC = {
          lW: '[a-z]',//小写字母
          uW: '[A-Z]',//大写字母
          nW: '[0-9]',//数字
          sW: '[\\u0020-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E]'//特殊字符
        };
        function Reg(str, rStr) {
          var reg = new RegExp(rStr);
          if (reg.test(str)) {
            return true;
          } else {
            return false;
          }
        }
        if (str.length < 8) {
          alert("请至少输入8位及以上密码");
          return false;
        } else {
          var tR = {
            l: Reg(str, rC.lW),
            u: Reg(str, rC.uW),
            n: Reg(str, rC.nW),
            s: Reg(str, rC.sW)
          };
          if ((tR.l && tR.u && tR.n) || (tR.l && tR.u && tR.s) || (tR.s && tR.u && tR.n) || (tR.s && tR.l && tR.n)) {
            //密码符合要求
            return true;
          } else {
            alert("请输入包含大写字母、小写字母、数字、标点及特殊字符四种字符中至少三种的组合");
            return false;
          }
        }
      }


    }
  }
</script>

<style lang="less" scoped>
  .ant-avatar-sm {
    width: 30px;
    height: 30px;
  }

  .avatar {
    margin: 20px 4px 20px 0;
    color: #1890ff;
    background: hsla(0, 0%, 100%, .85);
    vertical-align: middle;
  }

  .curr-user {
    font-weight: 600;
    margin-left: 6px
  }
</style>



// WEBPACK FOOTER //
// src/views/common/HeaderAvatar.vue